<template>
    <kt-input type="checkbox">
        <slot></slot>
    </kt-input>
</template>

<script>
export default {
}
</script>